import { useCallback } from 'react';
import { useGtmService, useMetrikaService } from '@funtech-int/yango-shared';

export const useSendWebAnalytics = () => {
    const gtmService = useGtmService();
    const metrika = useMetrikaService();

    return useCallback(
        (target: string, params?: Record<string, unknown>) => {
            metrika?.reachGoal(target, params);
            gtmService?.send({ ...params, event: target });
        },
        [gtmService, metrika]
    );
};
